import { company } from '@/config/company';
import { footerColumns, legalLinks, quoteCta } from '@/config/navigation';
import { footerPromo } from '@/content/site';
import { formatClockTime } from '@/utils/time';

export type FooterHoursRow = { label: string; range: string };

/**
 * Everything the footer shows, shaped for display. The footer's components
 * only lay this out; none of them reads config or formats values itself.
 */
export function useFooterContent() {
  const year = new Date().getFullYear();
  const { address } = company;

  return {
    brand: {
      badge: `Importing cars since ${company.established} · ${year - company.established}+ years`,
      pitch: footerPromo.pitch,
      highlights: footerPromo.highlights,
      quoteCta,
      whatsappMessage: footerPromo.whatsappMessage,
    },
    columns: footerColumns,
    contact: {
      addressLines: [`${address.building}, ${address.unit}`, `${address.street}, ${address.city}`],
      postalLine: `${address.poBox}, ${address.country}`,
      directionsUrl: company.directionsUrl,
      phones: company.phones,
      email: company.email,
      inquiryEmail: company.inquiryEmail,
      hours: company.openingHours.map<FooterHoursRow>((h) => ({
        label: h.label,
        range: `${formatClockTime(h.opens)} – ${formatClockTime(h.closes)}`,
      })),
      closedNote: company.closedNote,
    },
    legal: {
      copyright: `© ${year} ${company.legalName} · ${company.motto}`,
      links: legalLinks,
    },
  };
}

export type FooterContent = ReturnType<typeof useFooterContent>;
